import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'kt-formly-field-text',
    templateUrl: './formly-field-text.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormlyFieldTextComponent extends FieldType<FieldTypeConfig> implements OnInit {
  constructor() {
    super()
  }

  get value() {
    return typeof this.formControl.value === 'boolean' ? this.formControl.value ? 'Yes' : 'No' : this.formControl.value;
  }

  ngOnInit(): void {
    this.props.disabled = true;
    this.props.required = false;
    this.props.placeholder = '';
  }
}
